import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ControlContainer, UntypedFormArray, UntypedFormControl, UntypedFormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { AppStateService } from '../app-state.service';
import { TypZaznamuTextu } from '../model/typ-zaznamu-textu';
import { ErrorDialogComponent } from 'projects/ais-common/src/public-api';
import { MatDialog } from '@angular/material/dialog';
import { FormService } from '../form.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-autocomplete-typ',
    templateUrl: './autocomplete-typ.component.html',
    styleUrls: ['./autocomplete-typ.component.css'],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective
        }
    ],
    standalone: false
})
export class AutocompleteTypComponent implements OnInit, OnDestroy {

  @Input() kodJazykIN: string;
  @Input() kodJazykRadioBox: string;
  @Input() typZaznamuTextu: TypZaznamuTextu;
  @Input() formularFormGroup: UntypedFormGroup;
  @Input() indexPolozkyVoFormulari: number;
  @Input() somPoslednaOpakovanaPolozka: boolean;

  @Output() zmenaHodnotyVAutocomplete = new EventEmitter<string>();

  pocetPrvychZnakovVoVyhladavani = 3;

  zobrazitClearButtonSK = true;

  zobrazitHelpTextSK = false;
  zobrazitHelpTextEN = false;

  mameDataCiselnikaJazyk1 = false;
  mameDataCiselnikaJazyk2 = false;
  mameDataCiselnikaJazyk3 = false;

  myControlJazyk1 = new UntypedFormControl();
  myControlJazyk2 = new UntypedFormControl();
  myControlJazyk3 = new UntypedFormControl();
  mapaControlsovVJazykoch: Map<string, UntypedFormControl> = new Map();

  myControlJazyk1Subscription: Subscription;
  myControlJazyk2Subscription: Subscription;
  myControlJazyk3Subscription: Subscription;

  ciselnikDataJazyk1Subscription: Subscription;
  ciselnikDataJazyk2Subscription: Subscription;
  ciselnikDataJazyk3Subscription: Subscription;

  optionsAutocompleteJazyk1: string[] = [];
  optionsAutocompleteJazyk2: string[] = [];
  optionsAutocompleteJazyk3: string[] = [];

  filteredOptionsJazyk1: Observable<string[]>;
  filteredOptionsJazyk2: Observable<string[]>;
  filteredOptionsJazyk3: Observable<string[]>;
  mapaFilteredOptionsVJazykoch: Map<string, Observable<string[]>> = new Map();

  pocetPoloziekJazyk1: number = 0;
  pocetPoloziekJazyk2: number = 0;
  pocetPoloziekJazyk3: number = 0;

  pocetPridanychPoloziekJazyk1: number = 0;
  pocetPridanychPoloziekJazyk2: number = 0;
  pocetPridanychPoloziekJazyk3: number = 0;

  jazykyFormularaPole: string[] = [];
  jazykFormulara1: string = 'SK';
  jazykFormulara2: string = '';
  jazykFormulara3: string = '';
  existujeVoFormulariJazyk2 = false;
  existujeVoFormulariJazyk3 = false;

  jeOpakovaniePodprogramu: boolean;

  formArrayJazyk1: UntypedFormArray = new UntypedFormArray([]);
  formArrayJazyk2: UntypedFormArray = new UntypedFormArray([]);
  formArrayJazyk3: UntypedFormArray = new UntypedFormArray([]);

  constructor(public appStateService: AppStateService,
    public dialog: MatDialog,
    public formService: FormService,
    private translateService: TranslateService) { }

  ngOnInit(): void {

    this.jazykyFormularaPole = this.appStateService.jazykyFormulara;
    this.jazykFormulara1 = this.jazykyFormularaPole[0];
    if (this.jazykyFormularaPole.length >= 2) {
      this.jazykFormulara2 = this.jazykyFormularaPole[1];
      this.existujeVoFormulariJazyk2 = true;
    }
    if (this.jazykyFormularaPole.length >= 3) {
      this.jazykFormulara3 = this.jazykyFormularaPole[2];
      this.existujeVoFormulariJazyk3 = true;
    }

    // this.myControlSK.setValidators(Validators.minLength(3));
    let menoControlsuJazyk1 = 'name_' + this.typZaznamuTextu.id + '_' + this.jazykFormulara1;
    let menoControlsuJazyk2 = 'name_' + this.typZaznamuTextu.id + '_' + this.jazykFormulara2;
    let menoControlsuJazyk3 = 'name_' + this.typZaznamuTextu.id + '_' + this.jazykFormulara3;
    if (this.typZaznamuTextu.idSkupina) {
      menoControlsuJazyk1 = 'name_' + this.typZaznamuTextu.idSkupina + '_' + this.jazykFormulara1;
      menoControlsuJazyk2 = 'name_' + this.typZaznamuTextu.idSkupina + '_' + this.jazykFormulara2;
      menoControlsuJazyk3 = 'name_' + this.typZaznamuTextu.idSkupina + '_' + this.jazykFormulara3;
    }

    this.jeOpakovaniePodprogramu = this.appStateService.jeOpakovaniePodprogramu(this.typZaznamuTextu);

    // OPAKOVANE, NIE VSAK SKUPINOVE POLOZKY - tie su riesene inak - priamo vo "formular.component.ts"
    if (this.typZaznamuTextu.opakovanie === 'A' || this.typZaznamuTextu.idSkupina
        || this.jeOpakovaniePodprogramu) {

      this.formArrayJazyk1 = <UntypedFormArray>this.formularFormGroup.get(menoControlsuJazyk1);
      this.pocetPoloziekJazyk1 = this.formArrayJazyk1.length;
      // pocet pridanych poloziek oproti minimu (minPocet)
      this.pocetPridanychPoloziekJazyk1 = this.pocetPoloziekJazyk1 - this.typZaznamuTextu.minPocet;
      this.myControlJazyk1 = <UntypedFormControl>(<UntypedFormArray>this.formularFormGroup.get(menoControlsuJazyk1))
        .get(this.indexPolozkyVoFormulari.toString());
      this.mapaControlsovVJazykoch.set(this.jazykFormulara1, this.myControlJazyk1);

      if (this.existujeVoFormulariJazyk2) {
        this.formArrayJazyk2 = <UntypedFormArray>this.formularFormGroup.get(menoControlsuJazyk2);
        this.pocetPoloziekJazyk2 = this.formArrayJazyk2.length;
        // pocet pridanych poloziek oproti minimu (minPocet)
        this.pocetPridanychPoloziekJazyk2 = this.formArrayJazyk2.length - this.typZaznamuTextu.minPocet;
        this.myControlJazyk2 = <UntypedFormControl>(<UntypedFormArray>this.formularFormGroup.get(menoControlsuJazyk2))
          .get(this.indexPolozkyVoFormulari.toString());
        this.mapaControlsovVJazykoch.set(this.jazykFormulara2, this.myControlJazyk2);
      }

      if (this.existujeVoFormulariJazyk3) {
        this.formArrayJazyk3 = <UntypedFormArray>this.formularFormGroup.get(menoControlsuJazyk3);
        this.pocetPoloziekJazyk3 = this.formArrayJazyk3.length;
        // pocet pridanych poloziek oproti minimu (minPocet)
        this.pocetPridanychPoloziekJazyk3 = this.formArrayJazyk3.length - this.typZaznamuTextu.minPocet;
        this.myControlJazyk3 = <UntypedFormControl>(<UntypedFormArray>this.formularFormGroup.get(menoControlsuJazyk3))
          .get(this.indexPolozkyVoFormulari.toString());
        this.mapaControlsovVJazykoch.set(this.jazykFormulara3, this.myControlJazyk3);
      }

    } else {

      if (this.typZaznamuTextu.idSkupina) {
        // const menoControlsuSK = 'name_' + this.typZaznamuTextu.idSkupina + '_SK';
        // const menoControlsuEN = 'name_' + this.typZaznamuTextu.idSkupina + '_EN';

        // const formArraySK = <FormArray>this.formularFormGroup.get(menoControlsuSK);
        // formArraySK.setControl(this.indexPolozkyVoFormulari, this.myControlSK);

        // this.formularFormGroup.setControl(menoControlsuSK, formArraySK);
        // this.formularFormGroup.setControl(menoControlsuEN, this.myControlEN);
      } else {
        this.formularFormGroup.setControl(menoControlsuJazyk1, this.myControlJazyk1);
        if (this.existujeVoFormulariJazyk2) {
          this.formularFormGroup.setControl(menoControlsuJazyk2, this.myControlJazyk2);
        }
        if (this.existujeVoFormulariJazyk3) {
          this.formularFormGroup.setControl(menoControlsuJazyk3, this.myControlJazyk3);
        }
      }

    }

    if (this.myControlJazyk1) {
      this.myControlJazyk1Subscription = this.myControlJazyk1.valueChanges
        .subscribe((value: string) => {
          // console.log('this.myControlJazyk1.valueChanges.subscribe');
          if (value && value.length === this.pocetPrvychZnakovVoVyhladavani) {
            // this.optionsAutocomplete = [];
            if (!this.mameDataCiselnikaJazyk1) {
              this.mameDataCiselnikaJazyk1 = true;
              // console.log('this.myControlJazyk1.valueChanges.subscribe fetchCiselnikSKData');
              this.appStateService.fetchCiselnikJazyk1Data(
                this.typZaznamuTextu.nazovCiselnika,
                this.typZaznamuTextu.atributCiselnika1,
                this.typZaznamuTextu.atributCiselnika2,
                value);
            }
          } else if (value && value.length < this.pocetPrvychZnakovVoVyhladavani) {
            // ak je retazec kratsi ako 3, budeme chciet pri opatovnom doplneni autocommpletu na 2(3) znaky
            // stiahnut ciselnikove data zo servra - preto to "false"
            this.mameDataCiselnikaJazyk1 = false;
          }
        });
    }

    if (this.existujeVoFormulariJazyk2 && this.myControlJazyk2) {
      this.myControlJazyk2Subscription = this.myControlJazyk2.valueChanges
        .subscribe((value) => {
          // console.log('Jazyk2 data: ' + value);
          if (value && value.length === this.pocetPrvychZnakovVoVyhladavani) {
            if (!this.mameDataCiselnikaJazyk2) {
              this.mameDataCiselnikaJazyk2 = true;
              // console.log('Jazyk2 data2: ' + value);
              this.appStateService.fetchCiselnikJazyk2Data(
                this.typZaznamuTextu.nazovCiselnika,
                this.typZaznamuTextu.atributCiselnika1,
                this.typZaznamuTextu.atributCiselnika2,
                value);
            }
          } else if (value && value.length < this.pocetPrvychZnakovVoVyhladavani) {
            // ak je retazec kratsi ako 3, budeme chciet pri opatovnom doplneni autocommpletu na 2(3) znaky
            // stiahnut ciselnikove data zo servra - preto to "false"
            this.mameDataCiselnikaJazyk2 = false;
          }
        });
    }

    if (this.existujeVoFormulariJazyk3 && this.myControlJazyk3) {
      this.myControlJazyk3Subscription = this.myControlJazyk3.valueChanges
        .subscribe((value) => {
          // console.log('JAzyk 3 data: ' + value);
          if (value && value.length === this.pocetPrvychZnakovVoVyhladavani) {
            if (!this.mameDataCiselnikaJazyk3) {
              this.mameDataCiselnikaJazyk3 = true;
              // console.log('Jazyk 3 data3: ' + value);
              this.appStateService.fetchCiselnikJazyk3Data(
                this.typZaznamuTextu.nazovCiselnika,
                this.typZaznamuTextu.atributCiselnika1,
                this.typZaznamuTextu.atributCiselnika2,
                value);
            }
          } else if (value && value.length < this.pocetPrvychZnakovVoVyhladavani) {
            // ak je retazec kratsi ako 3, budeme chciet pri opatovnom doplneni autocommpletu na 2(3) znaky
            // stiahnut ciselnikove data zo servra - preto to "false"
            this.mameDataCiselnikaJazyk3 = false;
          }
        });
    }

    if (this.myControlJazyk1) {
      this.filteredOptionsJazyk1 = this.myControlJazyk1.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value, this.jazykFormulara1))
      );
      this.mapaFilteredOptionsVJazykoch.set(this.jazykFormulara1, this.filteredOptionsJazyk1);
    }

    if (this.existujeVoFormulariJazyk2 && this.myControlJazyk2) {
      this.filteredOptionsJazyk2 = this.myControlJazyk2.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value, this.jazykFormulara2))
      );
      this.mapaFilteredOptionsVJazykoch.set(this.jazykFormulara2, this.filteredOptionsJazyk2);
    }

    if (this.existujeVoFormulariJazyk3 && this.myControlJazyk3) {
      this.filteredOptionsJazyk3 = this.myControlJazyk3.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value, this.jazykFormulara3))
      );
      this.mapaFilteredOptionsVJazykoch.set(this.jazykFormulara3, this.filteredOptionsJazyk3);
    }

    this.ciselnikDataJazyk1Subscription = this.appStateService.ciselnikJazyk1DataFetched
      .subscribe((data) => {
        this.optionsAutocompleteJazyk1 = data;
        // finta, aby sa vyvolala metoda valuechanges na controlse
        // - tym sa autocomplete dozvie, ze mame nove data k dispozicii
        // const v = this.myControlSK.value;
        // this.myControlSK.patchValue(v);
        this.myControlJazyk1.updateValueAndValidity({onlySelf:true});
      });

    this.ciselnikDataJazyk2Subscription = this.appStateService.ciselnikJazyk2DataFetched
      .subscribe((data) => {
        this.optionsAutocompleteJazyk2 = data;

        //finta, aby sa vyvolala metoda valuechanges na controlse
        // - tym sa autocomplete dozvie, ze mame nove data k dispozicii
        this.myControlJazyk2.updateValueAndValidity({onlySelf:true});

        // console.log('this.appStateService.ciselnikJazyk2DataFetched.subscribe');
      });

    this.ciselnikDataJazyk3Subscription = this.appStateService.ciselnikJazyk3DataFetched
      .subscribe((data) => {
        this.optionsAutocompleteJazyk3 = data;

        //finta, aby sa vyvolala metoda valuechanges na controlse
        // - tym sa autocomplete dozvie, ze mame nove data k dispozicii
        this.myControlJazyk3.updateValueAndValidity({onlySelf:true});

        // console.log('this.appStateService.ciselnikJazyk3DataFetched.subscribe');
      });

  }

  private _filter(value: string, jazyk: string): string[] {

    if (!value || value.length < 3) {
      return;
    }

    // console.log('this.optionsAutocompleteJazyk1 : ' + JSON.stringify(this.optionsAutocompleteJazyk1));
    // console.log('this.optionsAutocompleteJazyk2 : ' + JSON.stringify(this.optionsAutocompleteJazyk2));
    // console.log('this.optionsAutocompleteJazyk3 : ' + JSON.stringify(this.optionsAutocompleteJazyk3));
    // console.log('value: ' + value);

    const filterValue = value.toLowerCase();
    if (jazyk === this.jazykFormulara1 && this.optionsAutocompleteJazyk1) {
      this.zmenaHodnotyVAutocomplete.emit(value);
      return this.optionsAutocompleteJazyk1.filter(option => option.toLowerCase().includes(filterValue));
    } else if (jazyk === this.jazykFormulara2 && this.optionsAutocompleteJazyk2) {
      this.zmenaHodnotyVAutocomplete.emit(value);
      return this.optionsAutocompleteJazyk2.filter(option => option.toLowerCase().includes(filterValue));
    } else if (jazyk === this.jazykFormulara3 && this.optionsAutocompleteJazyk3) {
      this.zmenaHodnotyVAutocomplete.emit(value);
      return this.optionsAutocompleteJazyk3.filter(option => option.toLowerCase().includes(filterValue));
    }

  }

  pridatPolozku(jazyk: string){
    if (!(this.typZaznamuTextu.podprogram === 1)) {
      this.pocetPoloziekJazyk1 = this.formArrayJazyk1.length;
      this.pocetPoloziekJazyk2 = this.formArrayJazyk2.length;
      this.pocetPoloziekJazyk3 = this.formArrayJazyk3.length;
      const text = this.translateService.instant('Už je pridaný maximálny povolený počet');
      if (jazyk === this.jazykFormulara1) {
        if (this.pocetPoloziekJazyk1 >= this.typZaznamuTextu.maxPocet) {
          this.openErrorDialog(text + ' ' + jazyk + ' ' + this.translateService.instant('položiek') + '.');
          return;
        }
      } else if (jazyk === this.jazykFormulara2) {
        if (this.pocetPoloziekJazyk2 >= this.typZaznamuTextu.maxPocet) {
          this.openErrorDialog(text + ' ' + jazyk + ' ' + this.translateService.instant('položiek' + '.'));
          return;
        }
      } else if (jazyk === this.jazykFormulara3) {
        if (this.pocetPoloziekJazyk3 >= this.typZaznamuTextu.maxPocet) {
          this.openErrorDialog(text + ' ' + jazyk + ' ' + this.translateService.instant('položiek') + '.');
          return;
        }
      }
    }

    const name = 'name_' + this.typZaznamuTextu.id + '_' + jazyk;
    const control = new UntypedFormControl('');
    (<UntypedFormArray>this.formularFormGroup.get(name)).push(control);
    if (jazyk === this.jazykFormulara1) {
      this.pocetPoloziekJazyk1++;
      this.pocetPridanychPoloziekJazyk1++;
    } else if (jazyk === this.jazykFormulara2) {
      this.pocetPoloziekJazyk2++;
      this.pocetPridanychPoloziekJazyk2++;
    } else if (jazyk === this.jazykFormulara3) {
      this.pocetPoloziekJazyk3++;
      this.pocetPridanychPoloziekJazyk3++;
    }

  }

  vymazObsahPolozky(jazyk: string, index? : number) {
    this.appStateService.vymazObsahPolozkyFormulara(this.formularFormGroup,
      this.typZaznamuTextu, jazyk, index)
  }


  getIdControlName(jazyk: string) {
    let result = '';
    if (this.typZaznamuTextu.opakovanie === 'A') {
      result = 'name_' + this.typZaznamuTextu.id + '_' + this.indexPolozkyVoFormulari + '_' + jazyk;
    } else {
      result = 'name_' + this.typZaznamuTextu.id + '_' + jazyk;
    }

    return result;
  }

  getFormControlName(jazyk: string) {
    let result = '';
    if (this.typZaznamuTextu.opakovanie === 'A') {
      result = this.indexPolozkyVoFormulari.toString();
    } else {
      result = 'name_' + this.typZaznamuTextu.id + '_' + jazyk;
    }

    return result;
  }

  getFormArrayName(jazyk: string): string {
    let result = '';
    if (this.typZaznamuTextu.opakovanie === 'A') {
      result = 'name_' + this.typZaznamuTextu.id + '_' + jazyk;
    } else {
    }

    return result;
  }

  openErrorDialog(msg: string) {
    this.dialog.open(ErrorDialogComponent, {
      panelClass: 'alert-danger',
        data: {message: msg},
        width: '500px',
      });
  }

  ngOnDestroy() {
    if (this.myControlJazyk1Subscription) {
      this.myControlJazyk1Subscription.unsubscribe();
    }
    if (this.myControlJazyk2Subscription) {
      this.myControlJazyk2Subscription.unsubscribe();
    }
    if (this.myControlJazyk3Subscription) {
      this.myControlJazyk3Subscription.unsubscribe();
    }
    if (this.ciselnikDataJazyk1Subscription) {
      this.ciselnikDataJazyk1Subscription.unsubscribe();
    }
    if (this.ciselnikDataJazyk2Subscription) {
      this.ciselnikDataJazyk2Subscription.unsubscribe();
    }
    if (this.ciselnikDataJazyk3Subscription) {
      this.ciselnikDataJazyk3Subscription.unsubscribe();
    }
  }

  getPridatPolozkuTooltip() {
    let result
      = this.translateService.instant('Pridať položku') + ' ('
        + this.translateService.instant('max. počet je') +  ' ' + this.typZaznamuTextu.maxPocet + ')';
    if (this.typZaznamuTextu.opakovanie !== 'A' &&  this.typZaznamuTextu.podprogram === 1) {
      result = this.translateService.instant('Pridať položku');
    }

    return result;
  }

  // getSpolocnaPolozkaText(index: number): string {
  //   let result = '';

  //   const zaznamy = this.appStateService.mapaIdTypovAZaznamovsPodprogramami.get(this.typZaznamuTextu.id);
  //   if (zaznamy && zaznamy.length > index) {

  //       result = 'Spoločná položka podprogramu ' +
  //         this.appStateService.mapaIdTypovAZaznamovsPodprogramami.get(this.typZaznamuTextu.id)[index].podprogram;
  //     }

  //   return result;
  // }

  // indexDruhejPolozky - index druhej polozky z tych dvoch poloziek, ktore medzi sebou vymienam
  vymenPolozky(indexDruhejPolozky: number, kodJazyk: string) {

    this.formService.vymenPolozky(this.formularFormGroup,
      this.typZaznamuTextu, indexDruhejPolozky, kodJazyk)

  }

  getVymenitObsahPoloziekTooltip() {
    return this.translateService.instant('Vymeniť obsah položiek');
  }

  getZmazatTextTooltip() {
    return this.translateService.instant("Zmazať text");
  }

  getZadajteTextPlaceholder() {
    return this.translateService.instant('Zadajte text');
  }


}
